class HulkCustomFlagPins {
    constructor() {
        this.state = {
            optionSet: null,
            uploadedImg: null
        };
        this.init();
    }

    init() {
        window.addEventListener("load", () => {
            const polling = setInterval(() => {
                const optionSet = document.querySelector("div[id^='hulkapps_custom'] .hulkapps_option_set");
                if (optionSet) {
                    clearInterval(polling);
                    this.state.optionSet = optionSet;
                    setTimeout(() => this.main(), 100);
                }
            }, 100);
            setTimeout(() => clearInterval(polling), 20000);
        });
    }

    main() {
        this.handleImageUpload();
    }

    handleImageUpload() {
        const container = document.querySelector(".product-media.product-media--image .rimage-wrapper");
        const fileInput = this.state.optionSet.querySelector("input[type='file']");
        const productImage = container.querySelector(".rimage__image");

        if (!container || !fileInput) return;

        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        
        canvas.style.position = "absolute";
        canvas.style.top = "0";
        canvas.style.left = "0";
        canvas.style.width = "100%";
        canvas.style.height = "100%";
        canvas.style.pointerEvents = "none";
        container.appendChild(canvas);

        const drawImageOnCanvas = () => {
            if (!this.state.uploadedImg) return;

            const imgSource = this.state.uploadedImg;
            
            canvas.width = container.offsetWidth;
            canvas.height = container.offsetHeight;

            const centerX = canvas.width / 2;
            const verticalOffset = canvas.width * 0.155; 
            const centerY = (canvas.height / 2) - verticalOffset;
            const radius = canvas.width * 0.245; 

            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.save();
            
            ctx.beginPath();
            ctx.arc(centerX, centerY, radius, 0, Math.PI * 2, true);
            ctx.closePath();
            
            ctx.fillStyle = "#FFFFFF";
            ctx.fill();
            
            ctx.clip();

            const aspect = imgSource.width / imgSource.height;
            let drawWidth, drawHeight;

            if (aspect > 1) {
                drawHeight = radius * 2;
                drawWidth = drawHeight * aspect;
            } else {
                drawWidth = radius * 2;
                drawHeight = drawWidth / aspect;
            }

            ctx.drawImage(
                imgSource, 
                centerX - drawWidth / 2, 
                centerY - drawHeight / 2, 
                drawWidth, 
                drawHeight
            );
            ctx.restore();
        };

        fileInput.addEventListener("change", (e) => {
            const file = e.target.files[0];
            if (!file) return;

            const reader = new FileReader();
            reader.onload = (event) => {
                const img = new Image();
                img.onload = () => {
                    this.state.uploadedImg = img;
                    drawImageOnCanvas();
                };
                img.src = event.target.result;
            };
            reader.readAsDataURL(file);
        });

        const resizeObserver = new ResizeObserver(() => {
            if (this.state.uploadedImg) {
                drawImageOnCanvas();
            }
        });
        resizeObserver.observe(container);
    }
}

new HulkCustomFlagPins();